import { LEAccordionItem } from '../../../../../components/LEAccordion';
import { ItemStatusType } from '../../../../../components/LEAccordion/utils';
import MarketplacePrelistPhotoStep from './MarketplacePrelistPhotoStep';
import MarketplacePrelistPhotosAndIdStep from './MarketplacePrelistPhotosAndIdStep';

type MarketplacePrelistPhotoItemProps = {
  dealId: string;
  isLast: boolean;
  initialStatus?: ItemStatusType;
  photosAndIdVariant?: boolean;
};

const MarketplacePrelistPhotoItem = ({
  dealId,
  isLast,
  initialStatus,
  photosAndIdVariant = false,
}: MarketplacePrelistPhotoItemProps) => {
  return (
    <LEAccordionItem
      accordionKey={photosAndIdVariant ? 'photos-id' : 'photo'}
      title={photosAndIdVariant ? 'PHOTOS & ID' : 'ADD A PHOTO'}
      initialStatus={initialStatus}
    >
      {photosAndIdVariant ? (
        <MarketplacePrelistPhotosAndIdStep dealId={dealId} isLast={isLast} />
      ) : (
        <MarketplacePrelistPhotoStep dealId={dealId} isLast={isLast} />
      )}
    </LEAccordionItem>
  );
};

export default MarketplacePrelistPhotoItem;
